import { formatDistanceToNow, parseISO, differenceInDays } from 'date-fns';

// Format ISO date to relative time using date-fns
export function formatLastLogin(isoDate: string | null | undefined): string {
  if (!isoDate) {
    return 'Never';
  }
  try {
    return formatDistanceToNow(parseISO(isoDate), { addSuffix: true });
  } catch (error) {
    console.error('Error formatting last login date:', error);
    return 'Never';
  }
}

// Check if user is active (logged in within 7 days) using date-fns
export function isUserActive(lastLogin: string | null | undefined): boolean {
  if (!lastLogin) {
    return false;
  }
  try {
    return differenceInDays(new Date(), parseISO(lastLogin)) < 7;
  } catch (error) {
    return false;
  }
}

